export default __webpack_public_path__ + "static/media/27_SchererGruppe-DTM-Documentary-EschweilerPhotography_M1A3096.232bdd94.jpg";